import { defineMessages, type MessageDescriptor } from 'react-intl';

export const reviewButtonMessages: { suggestionsLabel: MessageDescriptor } = defineMessages({
	suggestionsLabel: {
		id: 'object-sidebar-components.suggestions.button.label',
		defaultMessage: 'Suggestions',
		description:
			'Tooltip and accessible label for the sparkle icon button in the object sidebar that opens AI suggestions in the editor',
	},
});
